/**
 * Frontend Environment Configuration
 * Simple environment variable access for React frontend
 */

export const ENV_CONFIG = {
  // API Configuration
  API_URL: process.env.REACT_APP_API_URL || 'https://api.recrutementcdp.juniorisep.com',
  
  // App Configuration
  NODE_ENV: process.env.NODE_ENV || 'development',
  PORT: process.env.PORT || '3001',
  
  // Environment checks
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

